import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { createRoutesFromChildren, matchRoutes } from 'react-router-dom';
import App, { appRoutes } from './App';
import reportWebVitals from './reportWebVitals';

// ビルド後のプリレンダー（scripts/prerender.js）が、このバンドルを動かして書き出すページの一覧を受け取る。
// 一覧はページのデータを読むので、プリレンダーが求めたときだけ読み込む（ふだんの JavaScript を重くしない）
const prerender = window.__SALT2_PRERENDER__;
const prerenderReady = prerender?.wantRoutes
  ? import('./lib/prerenderRoutes').then((m) => {
      prerender.routes = m.prerenderRoutes();
    })
  : Promise.resolve();

// 開いたページの JavaScript（ページごとに分けたもの。lib/lazyPage.js）を先に読み込む。失敗しても描く（描くときに読み直す）
const preloadCurrentPage = () => {
  const matches = matchRoutes(createRoutesFromChildren(appRoutes), window.location.pathname) || [];
  const loads = matches.map((m) => m.route.element?.type?.preload).filter(Boolean);
  return Promise.all(loads.map((preload) => preload())).catch(() => {});
};

// #root には、ビルド後に書き出した「画面を作り終えた状態の HTML」が入っている（検索エンジン・AI 向け）。
// ページの JavaScript が届くまではそれを見せておき、届いてから createRoot で描き直す
// （hydrate しない。最初の描画はプリレンダーと同じ内容なので見た目は変わらない）
Promise.all([prerenderReady, preloadCurrentPage()]).then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
